<template>
  <div class="product-display">
<!--    授权产品-->
    <section v-if="yourProject.length > 0">
      <h3>授权产品</h3>
      <div>
        <ul>
          <li
            v-for="(item, index) in yourProject"
            :key="index"
            class="product-item"
            :class="item.version == 1 ?
            'beta_view' : (item.version == 2?'type_old':'')"
          >
            <em v-if="item.status == 0" class="probation">试用</em>
            <!-- <em v-else-if="item.status == 2" class="free">免费</em> -->
            <div class="type_view type_beta" :class="item.version == 1 ? 'type_beta' : ''">
              <div v-if="item.projectCn != '院校情报APP'" class="version_icon" :class="item.version == 1 ? 'new_icon' : (item.version == 2?'old_icon':'')">
                <a >{{ item.version == 1 ? '新版' : (item.version == 2?'旧版':'') }}</a>
              </div>
            </div>
            <span class="short-name" :class="`${item.icon}_font`"><i :class="item.icon"></i></span>
            <div class="long-name">
              <dl>
                <dd>{{ item.projectCn }}</dd>
                <dd v-if="item.status == 0" style="margin-top:12px">试用期剩余 {{ item.canUseDays }}天</dd>
                <dd v-else></dd>
              </dl>
            </div>
            <div>
              <el-button v-if="item.isOnline == 0" class="disable-button">
                <a>{{ item.clickGo }}</a>
              </el-button>
              <el-button v-else :class="item.button" @click="clickHandler(item)">
                {{ item.clickGo }}<i v-if="item.button == 'download-button'" class="icon-down"></i>
              </el-button>
            </div>
            <p v-if="item.isOffline" class="tip">{{ item.offline }}</p>
          </li>
        </ul>
      </div>
    </section>

<!--    离线产品-->
    <section
        v-if="offlineProject!=null&&offlineProject.length > 0">
      <h3>归档产品</h3>
      <ul>
        <li
          v-for="(item, index) in offlineProject"
          :key="index"
          class="product-item"
          :class="item.version == 1 ? 'beta_view' : ''"
        >
          <em v-if="item.status == 0" class="probation">试用</em>
          <!-- <em v-else-if="item.status == 2" class="free">免费</em> -->
          <div class="type_view "
               :class="item.version == 1 ?
               'type_beta' : ''">
            <div v-if="item.version != 0" class="version_icon" :class="item.version == 1 ? 'new_icon' : 'old_icon'">
              <a>{{ item.version == 1 ? '新版' : '旧版' }}</a>
            </div>
          </div>
          <span class="short-name" :class="`${item.icon}_font`"><i :class="item.icon"></i></span>
          <div class="long-name">
            <dl>
              <dd>{{ item.projectCn }}</dd>
              <dd v-if="item.status == 0" style="margin-top:12px">试用期剩余 {{ item.canUseDays }}天</dd>
              <dd v-else></dd>
            </dl>
          </div>
          <div>
            <el-button v-if="item.isOnline == 0" class="disable-button">
              <a>{{ item.clickGo }}</a>
            </el-button>
            <el-button v-else :class="item.button" @click="clickHandler(item)">
              {{ item.clickGo }}<i v-if="item.button == 'download-button'" class="icon-down"></i>
            </el-button>
          </div>
          <p v-if="item.isOffline" class="tip">{{ item.offline }}</p>
        </li>
      </ul>
    </section>

    <!--  调查服务 前端写死的值  暂不展示-->
    <section style="display: none">
      <h3>调查服务</h3>
      <div>
        <ul>
          <li v-for="(item, index) in SurveyServices" :key="index" class="product-item">
            <span class="short-name" :class="`${item.icon}_font`"
              ><i style="height:29px" :class="`${item.icon}`"></i
            ></span>
            <div class="long-name" style="margin-top: 17px;margin-bottom: 5px;">
              <dl>
                <dd
                  style="color:#efa54d;padding: 7px;font-size: 14px;background-color: RGBA(239,165,77,0.17);border-radius: 3px;line-height: 14px;"
                >
                  {{ item.remark }}
                </dd>
                <dd></dd>
              </dl>
            </div>
            <div class="long-name" style="margin-top: 5px;margin-bottom: 26px;">
              <dl>
                <dd>{{ item.projectCn }}</dd>
                <dd></dd>
              </dl>
            </div>
            <div class="mini-button">
              <el-button class="detail-button" @click="clickHandler(item)"
                ><a>{{ item.clickGo }}</a></el-button
              >
              <el-button
                class="apply-button"
                @click="clickHandler({ button: 'detail-button', viewDetailsUrl: item.viewDetailsUrl2 })"
                ><a>⽴即参与</a></el-button
              >
            </div>
          </li>
        </ul>
      </div>
    </section>
<!--未授权产品-->
    <section v-if="noPayProject.length > 0">
      <h3>未授权产品</h3>
      <div>
        <ul>
          <li v-for="(item, index) in noPayProject" :key="index" class="disable product-item">
            <span class="short-name" :class="`${item.icon}_font-disable`"><i :class="`${item.icon}-disable`"></i></span>
            <div class="long-name">
              <dl>
                <dd>{{ item.projectCn }}</dd>
                <dd></dd>
              </dl>
            </div>
            <!-- <div v-if="item.shortName == '学科监测' || item.shortName == '院系绩效'" class="mini-button"> -->
            <div class="mini-button" v-if="item.viewDetailsUrl">
              <el-button
                class="detail-button"
                @click="clickHandler({ button: 'detail-button', viewDetailsUrl: item.viewDetailsUrl })"
                >产品介绍</el-button
              >
              <el-button v-if="item.isOnline == 0" class="disable-button">
                <a>{{ item.clickGo }}</a>
              </el-button>
              <el-button v-else :class="item.button" @click="clickHandler(item)">{{ item.clickGo }}</el-button>
            </div>
            <div v-else>
              <template v-if="item.isOnline == 0">
                <el-button class="disable-button"
                  ><a>{{ item.clickGo }}</a></el-button
                >
              </template>
              <template v-else>
                <el-button :class="item.button" @click="clickHandler(item, false)">{{ item.clickGo }}</el-button>
              </template>
            </div>
          </li>
        </ul>
      </div>
    </section>
<!--分析报告 前端写死的值-->
    <section v-if="analysis.length > 0">
      <h3>分析报告</h3>
      <div>
        <ul>
          <li v-for="(item, index) in analysis" :key="index" class="disable product-item">
            <span class="short-name" :class="`${item.icon}_font-disable`"><i :class="`${item.icon}-disable`"></i></span>
            <div class="long-name">
              <dl>
                <dd>{{ item.projectCn }}</dd>
                <dd></dd>
              </dl>
            </div>
            <div>
              <el-button v-if="item.isOnline == 0" class="disable-button">
                <a>{{ item.clickGo }}</a>
              </el-button>
              <el-button v-else class="detail-button" @click="clickHandler(item)">{{ item.clickGo }}</el-button>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <el-dialog class="QRCode-dialog" center :show-close="true" @close="closeHandle" :visible.sync="showQRCode">
      <div class="left-content" v-if="showQRCode">
        <transition-group name="fadeIn" tag="div">
          <div v-for="(item, index) in classList" :key="index" :class="item" v-show="index == ingIndex"></div>
        </transition-group>
        <ul>
          <li v-for="(item, index) in 4" :key="item" :class="index == ingIndex ? 'curent' : ''"></li>
        </ul>
      </div>
      <div class="right-content" v-if="showQRCode">
        <h3>院校情报</h3>
        <p>
          简介：院校情报是全方位监测大学排名、学科排名、核心指标数据的移动平台。院校情报全面监测高校各类排名、无缝对接高绩数据平台，助力大学管理者实时掌握和便捷查看学校竞争力信息。
        </p>
        <div class="img_wrap">
          <div class="item">
            <img  :src="`${appImg}`" class="tooCode"></img>
<!--            <span>手机扫码下载（iOS）</span>-->
            <span>手机扫码下载</span>
          </div>
<!--          <div class="item" v-if="androidImg">-->
<!--            <img :src="`${androidImg}`" class="tooCode"></img>-->
<!--            <span>手机扫码下载（安卓）</span>-->
<!--          </div>-->
        </div>

      </div>
      <!-- <div slot="footer">
        <dl></dl>
          <dd>手机微信扫描二维码</dd>
          <dd>下载院校情报APP</dd>
        </dl>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { goProject } from '@/api/display.js';
import {getToken, removeToken} from '@/utils/auth';
import OtherLogin from '../login/pages/OtherLogin.vue';
import {getSessionStorage, setSessionStorage} from "@/utils/session";
export default {
  name: '',
  data() {
    return {
      ingIndex: 0,
      classList: ['a', 'b', 'c', 'd'],
      showQRCode: false,
      // appImg: this.$store.state.user.appImg,
      appImg: 'https://static.gaojidata.com/gaojidata/logo/app_qrcode.png',
      androidImg: this.$store.state.user.androidImg,
      analysis: [
        {
          shortName: '360报告',
          projectCn: '大学360度对比分析报告',
          clickGo: '报告简介',
          icon: 'icon-report_360',
          isOnline: 1,
          button: 'detail-button',
          viewDetailsUrl: 'https://www.shanghairanking.cn/_gj/report/360%E6%8A%A5%E5%91%8A.pdf',
        },
        {
          shortName: '国际对标',
          projectCn: '大学/学科国际对标分析报告',
          clickGo: '报告简介',
          icon: 'icon-report_national',
          isOnline: 1,
          button: 'detail-button',
          viewDetailsUrl: 'https://www.shanghairanking.cn/_gj/report/%E5%9B%BD%E9%99%85%E5%AF%B9%E6%A0%87.pdf',
        },
        {
          shortName: '定制分析',
          projectCn: '各类个性化定制分析报告',
          clickGo: '报告简介',
          icon: 'icon-report_vip',
          isOnline: 1,
          button: 'detail-button',
          viewDetailsUrl: 'https://www.shanghairanking.cn/_gj/report/%E5%AE%9A%E5%88%B6%E5%88%86%E6%9E%90.pdf',
        },
      ],
      SurveyServices: [
        {
          shortName: '中国⾼校数据共享计划',
          remark: '2020⾼校信息填报现已开启',
          projectCn: '中国⾼校数据共享计划',
          clickGo: '了解详情',
          icon: 'icon-dep',
          isOnline: 1,
          button: 'detail-button',
          viewDetailsUrl: 'http://product.gaojidata.com/img/ul/file/v1/1448175388604895232.pdf',
          viewDetailsUrl2: '', // 链接地址需要删除
        },
      ],
      timerID: null,
      // noPayProject: this.$store.state.user.noPayProject || [],
      // yourProject: this.$store.state.user.yourProject
    };
  },
  computed: {
    ...mapState('user', {
      noPayProject: 'noPayProject',
      yourProject: 'yourProject',
      offlineProject: 'offlineProject',
    }),
  },
  methods: {
    ...mapMutations('display', {
      SET_PROJECTNAME: 'SET_PROJECTNAME',
      SET_PROJECTCODE: 'SET_PROJECTCODE',
      SET_DETAILSURL: 'SET_DETAILSURL',
    }),
    clickHandler(item, flag) {
      const { button, projectName } = item;
      if (button == 'goto-button') { // 跳转链接
        this.get_into(item);
      } else if (button == 'download-button' || projectName == 'academyAPP') {
        this.download();
      } else if (button == 'detail-button') { // 产品介绍
        this.goto_detail(item);
      } else if (button == 'apply-button') { // 试用
        this.goto_apply_page(item);
      }
    },
    download() {
      this.showQRCode = true;
      this.openHandle();
    },
    openHandle() {
      this.ingIndex = 0;
      this.timerID = setInterval(() => {
        if (this.ingIndex == this.classList.length - 1) {
          this.ingIndex = 0;
        } else {
          this.ingIndex++;
        }
      }, 4000);
    },
    closeHandle() {
      clearInterval(this.timerID);
    },
    goto_detail({ viewDetailsUrl }) {
      // console.log(process.env.NODE_ENV);
      window.open(viewDetailsUrl);
    },
    goto_apply_page(item) {
      // console.log(process.env.NODE_ENV);
      this.SET_PROJECTCODE(item.Code);
      this.SET_PROJECTNAME(item.projectCn);
      this.SET_DETAILSURL(item.viewDetailsUrl);
      let href = location.href;
      let hash = location.hash;
      let openUrl = href.replace(hash, `#/apply`);
      window.location.href= openUrl;
    },
    // async get_into(param) {
    //   const { data } = await goProject({ projectName: param, token: getToken() });
    //   // if(data.message == "SUCCESS") {
    //   window.open(data.url);
    //   // } else {
    //   //   this.$message.error(data.message);
    //   // }
    // },
    get_into(param){
      const token = getToken()
      const url = param.Url + '?token=' + token
      console.log(url)
      window.open(url)
    }

    // opnePage(url){
    //   let href = location.href;
    //   let hash = location.hash;
    //   let openUrl = href.replace(hash, `#${url}`);
    //   window.open(openUrl);
    // }
  },
  components: { OtherLogin },
  mounted() {
    const url = getSessionStorage('loginUrl')
    if(url){
      const token = getToken()
      const target = decodeURIComponent(url) + '?token=' + token
      // setSessionStorage('loginUrl','')
      // 防止二次重登
      // removeToken()
      window.location = target
    }
  }
};
</script>
<style lang="scss">
.QRCode-dialog {
  .el-dialog {
    width: 1266px;
    height: 810px;
    margin-top: calc(50vh - 405px) !important;
    background: #ffffff;
    box-shadow: 0px 5px 35px 0px rgba(81, 77, 239, 0.1);
    border-radius: 10px;
    @media only screen and (max-width: 1520px) {
      width: 928px;
      height: 700px;
      // width: 65%;
      // height: 75%;
      margin-top: 50vh !important;
      transform: translateY(-50%);
    }
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        top: 17px;
        right: 17px;
      }
    }
    .el-dialog__body {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 0;
      & > div {
        height: 100%;
      }
      .left-content {
        width: 374px;
        @media only screen and (max-width: 1520px) {
          // width: 374px;
          width: 324px;
        }
        overflow: hidden;
        position: relative;
        ul {
          position: absolute;
          left: 50%;
          bottom: 43px;
          display: flex;
          justify-content: center;
          transform: translateX(-50%);
          li {
            width: 8px;
            height: 8px;
            border: solid 1px #3650ff;
            border-radius: 50%;
            margin: 0 6px;
            &.curent {
              background-color: #3650ff;
            }
            // cursor: pointer;
          }
        }
        .fadeIn-leave-active {
          transition: all 2s ease;
        }
        .fadeIn-enter-active {
          transition: all 2s ease;
        }
        .fadeIn-leave {
          left: 0%;
        }
        .fadeIn-leave-to {
          left: -100%;
        }
        .fadeIn-enter {
          transform: translateX(100%);
        }
        .fadeIn-enter-to {
          transform: translateX(0%);
        }
        div {
          background-repeat: no-repeat;
          background-size: contain;
          height: 100%;
          border-radius: 10px 0 0 10px;
          position: absolute;
          top: 0;
          width: 100%;
          left: 0;
          &.a {
            background-image: url('./images/1.png');
          }
          &.b {
            background-image: url('./images/2.png');
          }
          &.c {
            background-image: url('./images/3.png');
          }
          &.d {
            background-image: url('./images/4.png');
          }
        }
      }
      .right-content {
        flex: 1;
        display: flex;
        // justify-content: center;
        padding-top: 130px;
        @media only screen and (max-width: 1520px) {
          padding-top: 65px;
        }
        align-items: center;
        flex-direction: column;
        h3 {
          height: 37px;
          font-family: Microsoft YaHei;
          font-size: 28px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 37px;
          letter-spacing: 0px;
          color: #000000;
          margin-bottom: 52px;
        }
        p {
          width: 507px;
          height: 113px;
          font-family: Microsoft YaHei;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 28px;
          letter-spacing: 0px;
          color: #6c6d70;
        }
        .img_wrap{
          width: 100%;
          flex: 1;
          display: flex;
          justify-content: center;
          gap: 40px;
          align-items: center;
          margin-top: -60px;
          .item{
            display: flex;
            flex-direction: column;
            align-items: center;
            .tooCode {
              width: 173px;
              height: 173px;
              color: transparent;
              // background-image: url('~@/assets/qrcode.png');
              background-repeat: no-repeat;
              background-position: center;
              background-size: 100% 100%;
              //margin: 70px 0 30px;
              //@media only screen and (max-width: 1520px) {
              //  margin: 45px 0 30px;
              //}
            }
          }
        }
        span {
          height: 19px;
          font-family: Microsoft YaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 19px;
          letter-spacing: 0px;
          color: #929292;
        }
      }
    }
    .el-dialog__footer {
      font-size: 14px;
      font-family: 'Source Han Sans SC';
      font-weight: 400;
      color: #343438;
    }
  }
}
</style>
<style lang="scss" scoped>

.product-display {
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // padding: 50px 0;
  padding-top: 25px;
  section {
    // height: 45%;
    width: 1160px;
    margin: 0 auto;
    margin-bottom: 30px;
    &:last-of-type {
      margin-bottom: 0px;
    }
    h3 {
      font-size: 20px;
      line-height: 20px;
      text-align: left;
      margin-bottom: 35px;
      font-weight: 400;
    }
    div {
      height: calc(100% - 58px);
      ul {
        display: flex;
        // justify-content: space-between;
        height: 100%;
        flex-wrap: wrap;
        .beta_view {
          border: 1px solid rgba(81, 77, 239, 0.5);
        }
      }
    }
  }
  .type_old{
    background-color: #F7F7FC!important;
    border: 1px solid #F7F7FC!important;
  }
  .product-item {
    width: 353px;
    height: 270px;
    background: #ffffff;
    border: 1px solid #ffffff;
    box-shadow: 0px 5px 15px 0px rgba(81, 77, 239, 0.1);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    position: relative;
    &:nth-child(3n - 1) {
      margin-left: 50px;
      margin-right: 50px;
    }
    .tip {
      position: absolute;
      left: -1px;
      right: -1px;
      bottom: -1px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #f0aa57;
      font-size: 14px;
      background: #fcf0e1;
      border-radius: 0 0 5px 5px;
    }
    margin-bottom: 12px;
    @mixin tips($bgColor, $color) {
      width: 43px;
      height: 22px;
      line-height: 22px;
      border-radius: 4px;
      position: absolute;
      top: 19px;
      right: 12px;
      font-size: 12px;
      background: $bgColor;
      color: $color;
      font-style: initial;
      text-align: center;
    }
    .probation {
      @include tips(#f0f0f2, #514def);
    }
    .free {
      @include tips(#fdecd8, #efa54d);
    }

    .type_view {
      height: 44.44%;
      width: 100%;
      position: absolute;
      top: 0px;
      .version_icon {
        position: absolute;
        top: -1px;
        right: -1px;
        width: 52px;
        height: 26px;
        border-radius: 0px 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 14px;
        line-height: 14px;
      }
      .new_icon {
        background-color: #514def;
      }
      .old_icon {
        background-color: #868BB6;
      }
    }
    .type_beta {
      background: linear-gradient(180deg, rgba(81, 77, 239, 0.1) 0%, rgba(81, 77, 239, 0) 100%);
    }
    .short-name {
      height: 26px;
      line-height: 26px;
      display: flex;
      margin: 54px auto 0;
      font-size: 20px;
      font-family: 'Agency FB';
      font-weight: 400;
      // color: #514DEF;
      text-align: center;
      min-width: 122px;
      background-repeat: no-repeat;
      background-position: 37px center;
      position: relative;
      &.icon-360_font {
        background-image: url('~@/assets/images/display/icon_font_360.svg');
      }
      &.icon-360_font-disable {
        background-image: url('~@/assets/images/display/icon_font_3602.svg');
      }
      &.icon-vub_font{
        background-image: url('~@/assets/images/display/font_gaozhi_gray-1.png');
      }
      &.icon-vub_font-disable {
        background-image: url('~@/assets/images/display/font_gaozhi_gray.png');
      }
      &.icon-dpa_font {
        background-image: url('~@/assets/images/display/icon_font_dpa.svg');
      }
      &.icon-dpa_font-disable {
        background-image: url('~@/assets/images/display/icon_font_dpa2.svg');
      }
      &.icon-dep_font {
        background-image: url('~@/assets/images/display/icon_font_dep.svg');
      }
      &.icon-dep_font-disable {
        background-image: url('~@/assets/images/display/icon_font_dep2.svg');
      }
      &.icon-gaoji_font {
        background-image: url('~@/assets/images/display/icon_font_jixiao.svg');
      }
      &.icon-gaoji_font-disable {
        background-image: url('~@/assets/images/display/icon_font_jixiao2.svg');
      }
      &.icon-mpm_font {
        background-image: url('~@/assets/images/display/icon_font_mpm.svg');
      }
      &.icon-mpm_font-disable {
        background-image: url('~@/assets/images/display/icon_font_mpm2.svg');
      }
      &.icon-hsid_font {
        background-image: url('~@/assets/images/display/icon_font_zhibiao.svg');
      }
      &.icon-hsid_font-disable{
        background-image: url('~@/assets/images/display/icon_font_zhibiao2.svg');
      }
      &.icon-yuanxiao_font {
        background-image: url('~@/assets/images/display/icon_font_qingbao.svg');
      }
      &.icon-yuanxiao_font-disable {
        background-image: url('~@/assets/images/display/icon_font_qingbao2.svg');
      }
      &.icon-xueke_font {
        background-image: url('~@/assets/images/display/icon_font_xueke.svg');
      }
      &.icon-xueke_font-disable {
        background-image: url('~@/assets/images/display/icon_font_xueke2.svg');
      }
      &.icon-zhibiao_font {
        background-image: url('~@/assets/images/display/icon_font_zhibiao.svg');
      }
      &.icon-zhibiao_font-disable {
        background-image: url('~@/assets/images/display/icon_font_zhibiao2.svg');
      }
      &.icon-report_360_font-disable {
        background-image: url('~@/assets/images/display/report_font_360.svg');
      }
      &.icon-report_national_font-disable {
        background-image: url('~@/assets/images/display/report_font_national.svg');
      }
      &.icon-report_vip_font-disable {
        background-image: url('~@/assets/images/display/report_font_vip.svg');
      }
      &.icon-ubi_font {
        background-image: url('~@/assets/images/display/icon_font_ubi.svg');
      }
      &.icon-ubi_font-disable {
        background-image: url('~@/assets/images/display/icon_font_ubi2.svg');
      }
      &.icon-gras_font {
        width: 156px;
        background-image: url('~@/assets/images/display/icon_font_gras.svg');
      }
      &.icon-gras_font-disable {
        width: 156px;
        background-image: url('~@/assets/images/display/icon_font_gras2.svg');
      }
      &.icon-tal_font {
        background-size: 78px 19px;
        background-image: url('~@/assets/images/display/icon_font_tal.svg');
      }
      &.icon-tal_font-disable {
        background-size: 78px 19px;
        background-image: url('~@/assets/images/display/icon_font_tal2.svg');
      }
      i {
        display: inline-block;
        height: 26px;
        width: 29px;
        margin-right: 11px;
        background-repeat: no-repeat;
        background-position: center center;
        &.icon-360 {
          background-image: url('~@/assets/images/display/icon_360.svg');
        }
        &.icon-360-disable {
          background-image: url('~@/assets/images/display/icon_3602.svg');
        }

        &.icon-vub{
          background-size:29px 26px;
          background-image: url('~@/assets/images/display/icon_gaozhi_blue.svg');
        }
        &.icon-vub-disable{
          background-size:29px 26px;
          background-image: url('~@/assets/images/display/icon_gaozhi_gray.svg');
        }
        &.icon-dpa {
          background-image: url('~@/assets/images/display/icon_dpa.png');
        }
        &.icon-dpa-disable {
          background-image: url('~@/assets/images/display/icon_dpa2.png');
        }
        &.icon-gaoji {
          background-image: url('~@/assets/images/display/icon_jixiao.svg');
        }
        &.icon-gaoji-disable {
          background-image: url('~@/assets/images/display/icon_jixiao2.svg');
        }
        &.icon-mpm {
          background-image: url('~@/assets/images/display/icon_mpm.svg');
        }
        &.icon-mpm-disable {
          background-image: url('~@/assets/images/display/icon_mpm2.svg');
        }
        &.icon-hsid {
          background-size:29px 26px;
          background-image: url('~@/assets/images/display/icon_hsid.svg');
        }
        &.icon-hsid-disable {
          background-size:29px 26px;
          background-image: url('~@/assets/images/display/icon_hsid2.svg');
        }
        &.icon-xueke {
          background-image: url('~@/assets/images/display/icon_xueke.svg');
        }
        &.icon-xueke-disable {
          background-image: url('~@/assets/images/display/icon_xueke2.svg');
        }
        &.icon-yuanxiao {
          background-image: url('~@/assets/images/display/icon_qingbao.svg');
        }
        &.icon-yuanxiao-disable {
          background-image: url('~@/assets/images/display/icon_qingbao2.svg');
        }
        &.icon-zhibiao {
          background-image: url('~@/assets/images/display/icon_zhibiao.svg');
        }
        &.icon-zhibiao-disable {
          background-image: url('~@/assets/images/display/icon_zhibiao2.svg');
        }
        &.icon-report_360-disable {
          background-image: url('~@/assets/images/display/report_icon_360.svg');
        }
        &.icon-report_national-disable {
          background-image: url('~@/assets/images/display/report_icon_national.svg');
        }
        &.icon-report_vip-disable {
          background-image: url('~@/assets/images/display/report_icon_vip.svg');
        }
        &.icon-dep {
          background-image: url('~@/assets/images/display/icon_dep.svg');
        }
        &.icon-dep-disable {
          background-image: url('~@/assets/images/display/icon_dep2.svg');
        }
        &.icon-ubi {
          background-image: url('~@/assets/images/display/icon_ubi.svg');
        }
        &.icon-ubi-disable {
          background-image: url('~@/assets/images/display/icon_ubi2.svg');
        }
        &.icon-gras {
          background-image: url('~@/assets/images/display/icon_gras.svg');
        }
        &.icon-gras-disable {
          background-image: url('~@/assets/images/display/icon_gras2.svg');
        }
        &.icon-tal {
          background-image: url('~@/assets/images/display/icon_tal.svg');
        }
        &.icon-tal-disable {
          background-image: url('~@/assets/images/display/icon_tal2.svg');
        }
      }
    }
    .long-name {
      height: 44px;
      display: flex;
      justify-content: center;
      margin: 41px 0 18px;
      dl {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        &.explain {
          justify-content: space-between;
        }
        dd:first-child {
          font-size: 16px;
          font-weight: 400;
          color: #383838;
        }
        dd:last-child {
          // margin-top: 12px;
          font-size: 12px;
          font-weight: 400;
          color: #b0b0b5;
        }
      }
    }

    &.disable {
      background: #f7f7fc;
      border-color: #f7f7fc;
      box-shadow: 0px 5px 15px 0px #e8e7f8;
      .long-name {
        dl {
          dd:first-child {
            color: #a4a4ad;
          }
          dd:last-child {
            color: #a4a4ad;
          }
        }
      }
    }
    .mini-button {
      display: flex;
      justify-content: center;
    }
    .el-button {
      font-size: 13px;
      width: 150px;
      height: 42px;
      border-radius: 4px;
      margin: 0 auto;
      border: none;
      .icon-down {
        display: inline-block;
        height: 13px;
        width: 13px;
        margin-left: 6px;
        background: url('~@/assets/images/display/icon_download.svg') no-repeat;
      }
    }
    .mini-button {
      display: flex;
      .el-button {
        width: 89px;
        margin: 0 10px;
      }
    }
    @mixin baseButton($bgColor, $color, $hoverBgColor, $hoverColor) {
      color: $color;
      background: $bgColor;
      &:hover {
        color: $hoverColor;
        background: $hoverBgColor !important;
      }
    }
    .goto-button {
      // cursor: initial;
      @include baseButton(#514def, #ffffff, #5f5bfb, #ffffff);
    }
    .download-button {
      @include baseButton(#514def, #ffffff, #5f5bfb, #ffffff);
    }
    .detail-button {
      @include baseButton(#e2e2fe, #514def, #514def, #ffffff);
    }
    .apply-button {
      @include baseButton(#69c72a, #ffffff, #7cdd3b, #ffffff);
    }
    .disable-button {
      pointer-events: none;
      @include baseButton(#e2e2fe, #ffffff, #e2e2fe, #ffffff);
      color:#514def;
    }
  }
}
@media only screen and (max-width: 1366px) {
  .product-display {
    section {
      width: 85%;
      margin: 0 auto;
      margin-bottom: 30px;
      &:last-of-type {
        margin-bottom: 0px;
      }
      h3 {
        margin-bottom: 20px;
      }
      div {
        height: calc(100% - 58px);
        ul {
          li {
            width: calc((100% - 70px) / 3);
            height: 240px;
            position: relative;
            &:nth-child(3n - 1) {
              margin-left: 35px;
              margin-right: 35px;
            }
            margin-bottom: 12px;
            @mixin tips($bgColor, $color) {
              width: 43px;
              height: 22px;
              line-height: 22px;
              border-radius: 4px;
              position: absolute;
              top: 19px;
              right: 12px;
            }
            .short-name {
              height: 26px;
              line-height: 26px;
              margin: 42px auto 0;
            }
            .long-name {
              height: 44px;
              display: flex;
              justify-content: center;
              margin: 41px 0 18px;
              dl {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
                &.explain {
                  justify-content: space-between;
                }
                dd:first-child {
                  font-size: 16px;
                  font-weight: 400;
                  color: #383838;
                }
                dd:last-child {
                  // margin-top: 12px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #b0b0b5;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
